export default "/images/ChristopheHemmer.jpg?882bef8a6b2d84cd85c4eb8ae880fc2e";